import styled from 'styled-components';

export const Container = styled.div.attrs({ className: 'container' })`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
